module.exports = __webpack_public_path__ + "static/media/resourcesMessageReceived.31b6f3a3.png";